import Html from "./Contents/Html";
import View from "./Contents/View";
import Vimeo from './Contents/Vimeo'
import Pdf from "./Contents/Pdf";
import Quiz from "./Contents/Quiz";
import Assessment from "./Contents/Assessment";
import Download from "./Contents/Download";
import useCurrentSection from "./Hooks/useCurrentSection";
import useCourse from "./Hooks/useCourse";
import Google from "./Contents/Google";
import YouTube from "./Contents/YouTube";
import Review from './Contents/Review';
import Note from "./Contents/Note";
import { useParams } from "react-router-dom";
import Post from "./Contents/Post";
import useIsLocked from "./Hooks/useIsLocked";
import { Alert } from "@mui/material";
import Docs from "./Contents/Docs";
import Notes from "./Contents/Notes";
import Participation from "./Contents/Participation";
import PiSign from "./Contents/PiSign";
import Search from "./Contents/Search";
import Certificate from "./Contents/Certificate";
import Audit from "./Audit/Audit";
import Recommendations from "./Audit/Recommendations";
import Improvements from "./Audit/Improvements";
import Notion from "./Contents/Notion";
import Sponsor from "./Contents/Sponsor";

export default function Content(){

    const {tab, option} = useParams()

    const course = useCourse();
    const section = useCurrentSection();
    const [isLocked, message, severity] = useIsLocked();

    const optionIs = o => o === option 

    const tabIs = t => t === tab 

    const typeIs = type => {
        return !optionIs('post')
            && section?.type.id === type
            && !isLocked;
    }

    const typeIn = types => {
        return !optionIs('post')
            && types.includes(section?.type.id)
            && !isLocked;
    }
    
    return <section className='study-container'>

        <div className='study-content'>

            {isLocked &&
                <Alert severity={severity}>{message}</Alert>
            }

            {tabIs('docs') &&
                <Docs />
            }

            {tabIs('notes') &&
                <Notes />
            }

            {tabIs('epp') &&
                <Audit defaultTab='initial' showTabs />
            }

            {tabIs('fifpl') &&
                <Vimeo 
                    id={833968361}
                />
            }

            {tabIs('search') &&
                <Search />
            }

            {optionIs('post') && 
                <Post 
                    section={section} 
                />
            }

            {typeIs('video') &&
                <Vimeo 
                    id={section.vimeo?.id}
                />
            }

            {typeIs('view') &&
                <View 
                    view={section.view} 
                    enrollment={course.enrollment}
                />
            }

            {typeIn(['html', 'custom']) &&
                <Html
                    section={section} 
                />
            }

            {typeIs('notion') &&
                <Notion
                    section={section} 
                />
            }

            {typeIs('pdf') &&
                <Pdf
                    section={section} 
                />
            }

            {typeIs('quiz') &&
                <Quiz
                    section={section} 
                />
            }

            {typeIs('download') &&
                <Download
                    section={section} 
                />
            }

            {typeIs('google') &&
                <Google
                    section={section} 
                />
            }

            {typeIs('youtube') &&
                <YouTube
                    section={section} 
                />
            }

            {typeIs('review') &&
                <Review
                    course={course} 
                />
            }

            {typeIs('sponsor') &&
                <Sponsor />
            }

            {typeIs('participation') &&
                <Participation
                    id={course.enrollment?.dpc?.id} 
                />
            }

            {typeIs('pi_sign') &&
                <PiSign
                    id={course.enrollment?.dpc?.id} 
                />
            }

            {typeIs('audit_before') &&
                <Audit defaultTab='initial' />
            }

            {typeIs('audit_after') &&
                <Audit defaultTab='final' showTabs />
            }

            {typeIs('audit_reco') &&
                <Recommendations />
            }

            {typeIs('audit_actions') &&
                <Improvements />
            }

            {typeIn(['evaluation_start', 'evaluation_end']) &&
                <Assessment
                    section={section} 
                    enrollment={course.enrollment}
                />
            }

            {typeIs('certificate') &&
                <Certificate
                    enrollment={course.enrollment} 
                />
            }

        </div>

        {optionIs('note') &&
            <Note section={section} />
        }

    </section>    
}